export default "__VITE_ASSET__c0b501b4__"